import { create } from 'zustand';

import { StatusTypes } from 'api/traps/types';

interface ManageSetActivationSignalStatusModalState {
  id: string;
  isOpen: boolean;
  defaultStatus?: string;
  onManageSetActivationSignalStatusModalClose: () => void;
  onManageSetActivationSignalStatusModalOpen: (id: string, defaultStatus?: StatusTypes) => void;
}

export const useManageSetActivationSignalStatusModalStore = create<ManageSetActivationSignalStatusModalState>(set => ({
  isOpen: false,
  id: '',
  defaultStatus: undefined,
  onManageSetActivationSignalStatusModalClose: () => set({ isOpen: false, id: '' }),
  onManageSetActivationSignalStatusModalOpen: (id: string, defaultStatus?: StatusTypes) =>
    set({ isOpen: true, id, defaultStatus }),
}));
